<template>
  <div class="reportIndex">
    <ReportHead :userData="userData" />
    <div class="main">
      <div>
        <component
          v-for="item in componentList"
          :key="item.templateId"
          :is="item.elementName"
          :moduleIsShow="item.moduleIsShow"
          :templateIsShow="item.templateIsShow"
          :templateId="item.templateId"
          :title="item.moduleNameShow"
          :moduleAnnotation="item.moduleAnnotation"
        ></component>
      </div>
      <div v-if="empty">
        <van-skeleton title :row="10" />
      </div>
    </div>
    
  </div>
</template>
<script>
import { Components } from "../reportQuery/components/component";
import { getTemplate } from "@/api/reportQuery";
import { Toast } from "vant";
import { mapMutations } from "vuex";
import { findPatientMessage } from "@/api/wxapi.js";
// Toast.setDefaultOptions({ duration: 0 });
export default {
  name: "reportIndex",
  components: Components,
  data() {
    return {
      userData: [],
      All: [
        {
          name: "ImportantGene",
        },
        {
          name: "ZlAssess",
        },
        {
          name: "YcygVariation",
        },
        {
          name: "ByClass",
        },
        // {
        //   name:'Reference'
        // }
        // {
        //   name: "Appendix",
        // },
        // {
        //   name: "Dpart",
        // },
        // {
        //   name: "MutationList",
        // },
        // {
        //   name: "Ramucirumab",
        // },
        // {
        //   name: "Reference",
        // },
        // {
        //   name: "Typing",
        // },
        // {
        //   name: "Typingtips",
        // },
      ],
      componentList: [],
      labOriginalSampleNo: "F21092719T",
      productId: "fwa-p825",
      terminalCustomerNo: "P2109100206",
      // labOriginalSampleNo: "",
      // productId: "",
      title: "",
      empty: false,
    };
  },
  beforeCreate() {},
  created() {},

  mounted() {
    console.log(this.title);
    let params = {
      labOriginalSampleNo: this.$route.query.fname,
      productId: this.$route.query.fid,
    };
    this.setPublic(params);
    sessionStorage.setItem("params", params);

    this.getUserInfo();
  },

  methods: {
    ...mapMutations("embry", ["setPublic"]),
    getUserInfo() {
      findPatientMessage({
        terminalCustomerNo: this.$route.query.terminalCustomerNo,
        labOriginalSampleNo: this.$route.query.fname,
        productId: this.$route.query.fid,

        // terminalCustomerNo: this.terminalCustomerNo,
        // labOriginalSampleNo: this.labOriginalSampleNo,
        // productId: this.productId,
      }).then((res) => {
        console.log(res);
        this.userData = res.data;
        let param = {
          Product: res.data[0].productName,
          organization: res.data[0].hospital,
        };
        this.Template(param);
      });
    },
    // 获取模版接口
    async Template(param) {
      try {
        let { data } = await getTemplate({
          Product: param.Product,
          organization: param.organization,
        });
        this.componentList = data;
        // this.componentList.unshift({
        //   elementName: "geneVariation",
        // });
        console.log(this.componentList, 222);
        if (this.componentList == "") {
          this.empty = true;
        } else {
          this.empty = false;
        }
      } catch (error) {}
    },
  },
};
</script>
<style lang="less" scoped>
.reportIndex {
  .main {
    padding: 0 16px 30px;
  }
  font-family: @family;
}
</style>
